import { useEffect } from "react";
import { useLocation } from "react-router";
import { clearAnalyticsCache, trackPageView } from "@/utils/analytics";

const AnalyticsWrapper = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    clearAnalyticsCache();
    trackPageView(location.pathname);
  }, [location.pathname]);

  return children;
};

export default AnalyticsWrapper;
